import { Component, Input } from '@angular/core'
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { IBusy } from './base'

@Component({
    templateUrl: './busy.component.html',
    styleUrls: ['./modal.css'],
    standalone: true,
})
export class BusyComponent implements IBusy {
    constructor(private _activeModal: NgbActiveModal) {}

    public message!: string

    public done(): void {
        this._activeModal.close()
    }
}
